import history from "src/history";
import { isIE } from 'helpers/detectEdgeIE';

/**
 * This function will add inline style ( transform ) to table thead element to stick them
 * This will work in IE as well
 * @param {*} e Scroll event
 */
const stickyAASamplesHeaders = (e) => {
  const pathname = history.location.pathname;
  const isAA = pathname.includes('additional-analysis')

  if (isAA) {
    const aaSamplesThead = document.querySelector(".AA_samples_t_thead__samples");
    const aaPackagesThead = document.querySelector(".AA_samples_t_thead__packages");
    const shouldStick = aaSamplesThead !== null && aaPackagesThead !== null;

    const { scrollTop } = e.target;
    const offsetY = 350;
    const Y = scrollTop > offsetY ? scrollTop - offsetY : 0;

    if (shouldStick && Y >= 0) {
      const translateY = `translate(0,${Y}px)`;
      const fixedVerticalElts = document.querySelectorAll(
        '.AA_samples__table__header__buttons',
      );

      if (isIE()) {
        const fixedAASamplesTheadVerticalElts = aaSamplesThead.querySelectorAll('th')
        const fixedAAPackagesTheadVerticalElts = aaPackagesThead.querySelectorAll('th')

        for (let i = 0; i < fixedAASamplesTheadVerticalElts.length; i += 1) {
          fixedAASamplesTheadVerticalElts[i].style.transform = translateY;
        }

        for (let i = 0; i < fixedAAPackagesTheadVerticalElts.length; i += 1) {
          fixedAAPackagesTheadVerticalElts[i].style.transform = translateY;
        }
      } else {
        aaSamplesThead.style.transform = translateY;
        aaPackagesThead.style.transform = translateY;
      }


      for (let i = 0; i < fixedVerticalElts.length; i += 1) {
        fixedVerticalElts[i].style.transform = translateY;
      }
    }
  }
}

export default stickyAASamplesHeaders;



// WEBPACK FOOTER //
// ./src/containers/Forms/AdditionalAnalysis/_helpers/stickyHeaders.js